import { CostCentreResolverBase } from './cost-centre.resolver.base';
import { CostCentreService } from './cost-centre.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class CostCentreResolver extends CostCentreResolverBase {

  constructor(protected service: CostCentreService) {
    super(service);
  }
}



